import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Badge = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey300,
      children: [/*#__PURE__*/jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m6.871 7.048 1.36 1.557L11.192 5.5"
      }), /*#__PURE__*/jsx("path", {
        strokeLinejoin: "round",
        d: "M13 10.764v5.92a.5.5 0 0 1-.727.446l-3.255-1.656-3.293 1.66A.498.498 0 0 1 5 16.688v-5.924"
      }), /*#__PURE__*/jsx("circle", {
        cx: 9,
        cy: 7,
        r: 5.5
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Badge$1 = Svg18Badge;

export { Svg18Badge$1 as default };
